import { actionType } from "../actions/bybetjentseksjonerAction";
import { CreateNewReducer } from "../utils/reducerUtils";

const initialState = [];

const bybetjentSeksjonerReducer = (state = initialState, action) =>
  CreateNewReducer(state, action, actionType);

export default bybetjentSeksjonerReducer;
